module.exports = __webpack_public_path__ + "img/print-logo.b113b7c0.png";